'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

exports.default = memoize;



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/memoize/dist/memoize.browser.cjs.js
// module id = 386
// module chunks = 0